import Vue from 'vue';
import agencyDashboardAPI from '@/utils/api/agencyDashboard';
import { genericError } from '@/utils/alerts.service';
import { fileUpload } from '@/store/vendorDashboard/modules/fileUpload';

export const managePartnersDetail = {
  namespaced: true,
  state: {
    agencyTechPartnerID: '',
    agencyTechPartnerQuoteID: '',
    profile: {},
    useCases: [],
    useCasesToDelete: [],
    newUseCases: [],
    quotes: [],
    quotesToDelete: [],
    resources: [],
    newResources: [],
    resourcesToDelete: [],
    resourceLinkError: false,
    support: {},
    button: {},
    exisiting: {
      quotes: true,
      resources: true,
      support: true,
      button: true,
    },
    errors: {},
    dirty: [],
  },
  getters: {
    profileData(state) {
      return state.profile;
    },

    existingUseCases(state) {
      return state.useCases;
    },

    showHeaderBar(state) {
      return state.dirty.length > 0;
    },

    newUseCases(state) {
      return state.newUseCases;
    },

    // look into this
    useCases(state) {
      const activeOld = state.useCases.filter(x => !x.delete);
      const activeNew = state.newUseCases.filter(x => !x.delete);
      const useCases = [...activeOld, ...activeNew];
      useCases.sort((a, b) => a.order - b.order);
      return useCases;
    },

    quotes(state) {
      return state.quotes;
    },

    resources(state) {
      return state.resources;
    },

    newResources(state) {
      return state.newResources;
    },

    allResources(state) {
      const activeOld = state.resources.filter(x => !x.delete);
      const activeNew = state.newResources.filter(x => !x.delete);
      const resources = [...activeOld, ...activeNew];
      resources.sort((a, b) => a.order - b.order);
      return resources;
    },

    support(state) {
      return state.support;
    },

    button(state) {
      return state.button;
    },

    categories(state, getters, rootState, rootGetters) {
      return rootGetters.categories;
    },
  },
  mutations: {
    setProfile(state, data) {
      state.profile = data;
    },

    setError(state, data) {
      state.errors[data.key] = {
        label: data.label,
        state: data.state,
        message: data.message,
      };
    },

    setUseCases(state, data) {
      state.useCases = data;
    },

    addItemForUseCases(state, { data }) {
      state.useCases.push(data);
    },

    editItemForUseCases(state, { data }) {
      Vue.set(state.useCases, data.order || 0, data);

      if (data.order >= 0 && data.id) {
        Vue.set(state.useCases[data.order || 0], 'update', true);
      }
    },

    deleteItemForUseCases(state, { item }) {
      Vue.set(state.useCases[item.order], 'delete', true);
      state.useCasesToDelete.push(state.useCases[item.order]);
      state.useCases = state.useCases
        .filter(i => !i.delete)
        .map((item, i) => ({
          ...item,
          order: i,
          update: !item.new,
        }));
    },

    setQuotes(state, data) {
      if (!data.length) {
        state.exisiting.quotes = false;
      }
      state.quotes = data;
    },

    setResources(state, data) {
      state.resources = data;
    },

    updateResources(state, payload) {
      state.resources = payload;
    },

    setSupport(state, data) {
      if (!data) {
        state.exisiting.support = false;
      }

      state.support = data;
    },

    setButton(state, data) {
      if (!data.id) {
        state.exisiting.button = false;
      }

      state.button = data;
    },

    setStatus(state, payload) {
      state.profile.status = payload.value;
    },

    setAboutUs(state, value) {
      state.profile.renderAboutUs = value;
    },

    setSharedAboutUs(state, value) {
      state.profile.sharedAboutUs = value;
    },

    incrementUseCases(state, order) {
      state.newUseCases.push({ order, new: true });
    },

    clearNewUseCases(state) {
      state.newUseCases = [];
    },

    handleError(state, { key, value }) {
      state.errors[key] = value;
    },

    addItemForTestimonial(state, { data }) {
      state.quotes.push({
        ...data,
        agencyTechPartner: state.agencyTechPartnerID,
      });
    },

    editItemForTestimonial(state, { data }) {
      Vue.set(state.quotes, data.order || 0, data);

      if (data.order >= 0 || !data.order) {
        Vue.set(state.quotes[data.order || 0], 'update', true);
      }
    },

    deleteItemForTestimonial(state, { item }) {
      let testimonialItems = state.quotes.filter(i => i.quoteText);
      Vue.set(testimonialItems[item.order], 'delete', true);
      state.quotesToDelete.push(testimonialItems[item.order]);
      state.quotes = state.quotes.filter(i => !i.quoteText);
    },

    updateQuote(state, payload) {
      const { key, value } = payload;
      state.quotes[key] = value;
    },

    incrementResources(state, order) {
      state.newResources.push({ order, new: true });
    },

    clearNewResources(state) {
      state.newResources = [];
    },

    changeResourceOrder(state) {
      state.resources.sort((a, b) => {
        return a.order - b.order;
      });
    },

    updateSupport(state, payload) {
      const { key, value } = payload;
      state.support[key] = value;
    },

    updateButton(state, payload) {
      const { key, value } = payload;
      state.button[key] = value;
    },

    addDirtyTab(state, payload) {
      return state.dirty.push(payload);
    },

    changeUseCaseOrder(state) {
      state.useCases.sort((a, b) => {
        return a.order - b.order;
      });
    },

    clearDirtyTabs(state) {
      state.dirty = [];
    },

    setImage(state, payload) {
      state.profile[payload.field] = payload.uri;
      if (!state.dirty.includes('profile')) {
        state.dirty.push('profile');
      }
    },

    removeCategory(state, id) {
      state.profile.categories = state.profile.categories.filter(category => {
        return category !== id;
      });
    },

    addCategory(state, id) {
      state.profile.categories.push(id);
    },

    updateUseCaseOrder(state, { i, value }) {
      state.useCases[i]['order'] = value;
      state.useCases[i]['update'] = true;
    },

    updateNewUseCaseOrder(state, { i, value }) {
      state.newUseCases[i]['order'] = value;
    },

    updateResourceOrder(state, { i, value }) {
      state.resources[i]['order'] = value;
      state.resources[i]['update'] = true;
    },

    updateNewResourceOrder(state, { i, value }) {
      state.newResources[i]['order'] = value;
    },

    setWebsite(state, value) {
      state.profile.renderWebsite = value;
    },

    setAgencyTechPartnerID(state, value) {
      state.agencyTechPartnerID = value;
    },

    setAgencyTechPartnerQuoteID(state, value) {
      state.agencyTechPartnerQuoteID = value;
    },

    addItemForResources(state, { data }) {
      state.resources.push(data);
    },

    editItemForResources(state, { data }) {
      Vue.set(state.resources, data.order || 0, data);

      if (data.order >= 0 && data.id) {
        Vue.set(state.resources[data.order || 0], 'update', true);
      }
    },

    deleteItemForResources(state, { item }) {
      Vue.set(state.resources[item.order || 0], 'delete', true);
      state.resourcesToDelete.push(state.resources[item.order]);
      state.resources = state.resources.filter(i => !i.delete);
      state.resources = state.resources.map((item, index) => {
        return {
          ...item,
          order: index,
        };
      });
    },

    setresourceLinkError(state, data) {
      state.resourceLinkError = data;
    },
  },
  actions: {
    ...fileUpload.actions,

    async fetchProfile({ dispatch, commit }, id) {
      return agencyDashboardAPI
        .getManagePartnersProfile(id)
        .then(data => {
          commit('setProfile', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    clearPartner({ commit }) {
      commit('setProfile', {});
    },

    async fetchUseCases({ dispatch, commit }, id) {
      commit('setUseCases', []);
      commit('clearNewUseCases');

      return agencyDashboardAPI
        .getManagePartnersUseCases(id)
        .then(data => {
          commit('setUseCases', data.results);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async fetchQuotes({ dispatch, commit }, id) {
      return agencyDashboardAPI
        .getManagePartnersQuotes(id)
        .then(data => {
          if (
            !data[0].testimonialText &&
            !data[0].authorName &&
            !data[0].companyName &&
            !data[0].position
          ) {
            commit('setAgencyTechPartnerID', data[0].agencyTechPartner);
            commit('setAgencyTechPartnerQuoteID', data[0].id);
            return commit('setQuotes', []);
          }
          commit('setQuotes', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async fetchResources({ dispatch, commit }, id) {
      commit('setResources', []);
      commit('clearNewResources');
      return agencyDashboardAPI
        .getManagePartnersResources(id)
        .then(data => {
          const _data = data.results.map((item, index) => {
            return {
              ...item,
              order: index,
            };
          });
          commit('setResources', _data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async fetchSupport({ dispatch, commit }, id) {
      return agencyDashboardAPI
        .getManagePartnersSupport(id)
        .then(data => {
          commit('setSupport', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async fetchButton({ dispatch, commit }, id) {
      return agencyDashboardAPI
        .getManagePartnersCTA(id)
        .then(data => {
          commit('setButton', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    // TODO
    handleCheckboxChange({ commit, state }, id) {
      for (let category of state.profile.categories) {
        if (category === id) {
          commit('removeCategory', id);
          return commit('addDirtyTab', 'profile');
        }
      }
      commit('addCategory', id);
      return commit('addDirtyTab', 'profile');
    },

    updateError({ commit }, payload) {
      if (payload.key === 'resourceLink') {
        commit('setresourceLinkError', payload.state);
      } else {
        commit('setError', payload);
      }
    },

    addItemForTestimonial({ commit, dispatch }, payload) {
      commit('addItemForTestimonial', payload);
      dispatch('addDirtyTab', { storeKey: 'quotes' });
    },

    editItemForTestimonial({ commit, dispatch }, payload) {
      commit('editItemForTestimonial', payload);
      dispatch('addDirtyTab', { storeKey: 'quotes' });
    },

    deleteItemForTestimonial({ commit, dispatch }, payload) {
      commit('deleteItemForTestimonial', payload);
      dispatch('addDirtyTab', { storeKey: 'quotes' });
    },

    addItemForResources({ commit, dispatch }, payload) {
      commit('addItemForResources', payload);
      dispatch('addDirtyTab', { storeKey: 'resources' });
    },

    editItemForResources({ commit, dispatch }, payload) {
      commit('editItemForResources', payload);
      dispatch('addDirtyTab', { storeKey: 'resources' });
    },

    deleteItemForResources({ commit, dispatch }, payload) {
      commit('deleteItemForResources', payload);
      dispatch('addDirtyTab', { storeKey: 'resources' });
    },

    updateStatus({ commit, dispatch }, payload) {
      commit('setStatus', payload);
      dispatch('addDirtyTab', { storeKey: 'profile' });
    },

    updateWebsite({ commit }, value) {
      commit('setWebsite', value);
    },

    updateAboutUs({ commit }, value) {
      commit('setAboutUs', value);
    },

    updateSharedAboutUs({ commit }, value) {
      commit('setSharedAboutUs', value);
    },

    addItemForUseCases({ commit, dispatch }, payload) {
      commit('addItemForUseCases', payload);
      dispatch('addDirtyTab', { storeKey: 'useCases' });
    },

    editItemForUseCases({ commit, dispatch }, payload) {
      commit('editItemForUseCases', payload);
      dispatch('addDirtyTab', { storeKey: 'useCases' });
    },

    deleteItemForUseCases({ commit, dispatch }, payload) {
      commit('deleteItemForUseCases', payload);
      dispatch('addDirtyTab', { storeKey: 'useCases' });
    },

    // payload will include key (either title or description), value, and index of the use case
    updateUseCase({ commit }, payload) {
      commit('updateUseCase', payload);
    },

    updateNewUseCase({ commit }, payload) {
      commit('updateNewUseCase', payload);
    },

    removeUseCase({ commit, dispatch }, index) {
      commit('markUseCaseForDelete', index);
      dispatch('addDirtyTab', { storeKey: 'useCases' });
    },

    removeNewUseCase({ commit }, index) {
      commit('deleteNewUseCase', index);
    },

    updateQuote({ commit }, payload) {
      commit('updateQuote', payload);
    },

    addResource({ commit }, index) {
      commit('incrementResources', index);
    },

    updateResource({ commit }, payload) {
      commit('updateResource', payload);
    },

    updateNewResource({ commit }, payload) {
      commit('updateNewResource', payload);
    },

    removeResource({ commit, dispatch }, index) {
      commit('markResourceForDelete', index);
      dispatch('addDirtyTab', { storeKey: 'resources' });
    },

    removeNewResource({ commit }, index) {
      commit('deleteNewResource', index);
    },

    updateSupport({ commit }, payload) {
      commit('updateSupport', payload);
    },

    updateButton({ commit }, payload) {
      commit('updateButton', payload);
    },

    addDirtyTab({ commit, state }, payload) {
      if (!state.dirty.includes(payload.storeKey)) {
        commit('addDirtyTab', payload.storeKey);
      }
    },

    checkMainFields({ state, commit }) {
      return new Promise(resolve => {
        // Profile Info Check
        if (!state.profile.renderImage || state.profile.renderImage === '') {
          commit('setError', {
            key: 'profileLogo',
            state: true,
            label: 'Company logo',
          });
          document
            .querySelector('#companyLogo .file-input__area')
            .classList.add('fileError');
        } else {
          commit('setError', {
            key: 'profileLogo',
            state: false,
          });
        }

        if (
          !state.profile.renderWebsite ||
          state.profile.renderWebsite === '' ||
          !/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
            String(state.profile.renderWebsite).toLowerCase()
          )
        ) {
          commit('setError', {
            key: 'partnerWebsite',
            state: true,
            label: 'Partner website',
            message:
              'Please enter a valid website URL, containing either http:// or https://',
          });
          document.getElementById('profileWebsite').classList.add('inputError');
        } else {
          commit('setError', {
            key: 'partnerWebsite',
            state: false,
            label: 'Partner website',
          });
        }
        resolve();
      });
    },

    async saveChanges({ dispatch, state, commit }, id) {
      dispatch('checkMainFields').then(() => {
        for (let key of Object.keys(state.errors)) {
          if (state.errors[key].state) {
            dispatch(
              'showUserMessage',
              {
                success: false,
                title: 'Oops!',
                message:
                  state.errors[key].message ||
                  'Please fill in the ' + state.errors[key].label + ' field.',
              },
              { root: true }
            );
            return;
          }
        }

        // Use cases
        if (state.useCases && state.useCases.length) {
          for (let i of [...state.useCases, ...state.newUseCases]) {
            if (!i.title || !i.description) {
              const label = !i.title ? 'title' : 'description';
              return dispatch(
                'showUserMessage',
                {
                  success: false,
                  title: 'Oops!',
                  message: `Please make sure all use cases have a ${label}`,
                },
                { root: true }
              );
            }
          }
        }

        // Call to action section
        if (state.button && state.button.text) {
          if (state.button.text.length > 25) {
            return dispatch(
              'showUserMessage',
              {
                success: false,
                title: 'Oops!',
                message: `Please ensure that the button text/label has no more than 25 characters`,
              },
              { root: true }
            );
          }
        }

        let promises = [];

        if (state.dirty.includes('profile')) {
          promises.push(saveProfile(dispatch, state, id, commit));
        }

        if (state.dirty.includes('useCases')) {
          promises.push(saveUseCases(dispatch, state, id, commit));
        }

        if (state.dirty.includes('quotes')) {
          promises.push(saveQuote(dispatch, state, id, commit));
        }

        if (state.dirty.includes('resources')) {
          promises.push(saveResources(dispatch, state, id, commit));
        }

        if (state.dirty.includes('button')) {
          promises.push(saveButton(dispatch, state, id, commit));
        }

        commit('resetSaveProgress', null, { root: true });
        commit('setSaveTotalItems', promises.length + 1, { root: true });
        commit('setSaving', 'saving', { root: true });
        commit('addSaveProgress', null, { root: true });

        Promise.all(promises).then(() => {
          dispatch(
            'showUserMessage',
            {
              success: true,
              title: 'Success!',
              message: 'Your changes have been made.',
            },
            { root: true }
          );

          commit('clearDirtyTabs');
          commit('setSaving', 'idle', { root: true });
        });
      });
    },
  },
};

async function saveProfile(dispatch, state, id, commit) {
  return new Promise((resolve, reject) => {
    const data = {
      ...state.profile,
      image: state.profile.renderImage,
      website: state.profile.renderWebsite,
      aboutUs: state.profile.renderAboutUs,
    };
    return agencyDashboardAPI
      .saveManagePartnersProfile(id, data)
      .then(() => {
        commit('addSaveProgress', null, { root: true });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

async function saveUseCases(dispatch, state, id, commit) {
  return new Promise((resolve, reject) => {
    const data = [...state.useCases, ...state.newUseCases];
    return agencyDashboardAPI
      .saveManagePartnersUseCases(id, data)
      .then(() => {
        commit('addSaveProgress', null, { root: true });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

async function saveQuote(dispatch, state, id, commit) {
  return new Promise((resolve, reject) => {
    const quotes = state.quotes.map(i => {
      return {
        ...i,
        agencyTechPartner: id,
      };
    });

    return agencyDashboardAPI
      .createManagePartnersQuote(id, [...quotes, ...state.quotesToDelete])
      .then(res => {
        if (
          !res.data[0].testimonialText &&
          !res.data[0].authorName &&
          !res.data[0].companyName &&
          !res.data[0].position
        ) {
          commit('setQuotes', []);
        } else {
          commit('setQuotes', res.data);
        }
        commit('addSaveProgress', null, { root: true });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

async function saveResources(dispatch, state, id, commit) {
  return new Promise((resolve, reject) => {
    const data = [
      ...state.resources,
      ...state.newResources,
      ...state.resourcesToDelete,
    ];

    // We get an error from backend if file field is a empty string
    const _data = data.map(i => {
      if (i.file === '') {
        i.file = undefined;
        return i;
      }
      return i;
    });

    return agencyDashboardAPI
      .saveManagePartnersResources(id, _data)
      .then(res => {
        commit('clearNewResources');
        commit('setResources', res.data);
        commit('addSaveProgress', null, { root: true });
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}

async function saveButton(dispatch, state, id, commit) {
  return new Promise((resolve, reject) => {
    if (state.exisiting.button) {
      return agencyDashboardAPI
        .updateManagePartnersCTA(id, state.button)
        .then(() => {
          commit('addSaveProgress', null, { root: true });
          resolve();
        })
        .catch(() => {
          reject();
        });
    } else {
      return agencyDashboardAPI
        .saveManagePartnersCTA(id, state.button)
        .then(() => {
          commit('addSaveProgress', null, { root: true });
          resolve();
        })
        .catch(() => {
          reject();
        });
    }
  });
}
